module.exports = __webpack_public_path__ + "static/media/logo.455a970b.png";